import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
  }),
);

export const BackLinkWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const ContentWrapper = styled.div(() =>
  mq({
    width: '100%',
    minHeight: '300px',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
    marginTop: defaultTheme.spacing.xxl,
  }),
);
